<template>
  <div class="event-banner">
    <div class="content">
      <h3 class="title">신규 사장님을 위한 첫 구독 이벤트!</h3>
      <p class="subtitle">20% 할인된 가격으로 체험해 보세요</p>
      <button class="cta-button" @click="handleScrollToLargeBanner">혜택 자세히 보기</button>
    </div>
    <img src="@/assets/img/landing/price/percent-mobile.png" alt="퍼센트 아이콘" class="percentage-image" />
    <img src="@/assets/img/landing/price/megaphone-mobile.png" alt="메가폰 아이콘" class="megaphone-image" />
  </div>
</template>

<script>
export default {
  name: 'SmallBannerMobile',
  methods: {
    handleScrollToLargeBanner() {
      this.$emit('click-scroll-to-large-banner');
    },
  },
};
</script>

<style scoped lang="scss">
.event-banner {
  background: #fff0d9;
  border-radius: 12px;
  padding: 16px 24px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  margin: 24px 0;
}

.content {
  flex: 1;
  margin-right: 16px;
}

.title {
  color: #202020; //  var(--default-black) ||
  font-family: 'Spoqa Han Sans Neo', sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 26px;
  margin: 0 0 8px 0;
}

.subtitle {
  color: #5f5f5f;
  font-family: 'Spoqa Han Sans Neo', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  margin: 0 0 16px 0;
}

.cta-button {
  background: #3a3a3a;
  color: #fff;
  border: none;
  border-radius: 12px;
  padding: 12px 16px;
  font-family: 'Spoqa Han Sans Neo', sans-serif;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #555;
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }
}

.percentage-image {
  position: absolute;
  top: 30px;
  right: -6px;
  width: 115px;
  height: 116px;
  object-fit: contain;
  z-index: 1;
}

.megaphone-image {
  position: absolute;
  bottom: -10px;
  right: 20px;
  width: 124px;
  height: 106px;
  object-fit: contain;
  z-index: 2;
}
</style>
